module.exports = __webpack_public_path__ + "static/media/callpop-logo-black.4184b2f5.webp";